import { useTranslate } from '@tolgee/react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';

const CreatorTitle = ({
  title,
  tooltip = true,
  tooltipLink = null,
  tooltipPosition = 'top'
}) => {
  const { t } = useTranslate();
  return (
    <div className="d-flex align-items-center mb-3">
      <span className="fw-bold text-dark user-select-none me-1">
        {t(`lomavisCreator.title.${title}`)}
      </span>
      {tooltip && (
        <OverlayTrigger
          placement={tooltipPosition as any}
          delay={{ show: 0, hide: tooltipLink ? 1500 : 100 }}
          overlay={
            <Tooltip>
              <span className="text-gray-400 fw-bold d-block fs-7 text-start">
                {t(`lomavisCreator.tooltip.${title}`)}
              </span>
              {tooltipLink && (
                <div className="w-100 d-flex justify-content-end">
                  <a
                    className="text-primary fw-bold"
                    target="_blank"
                    href={tooltipLink}
                  >
                    {t(`lomavisCreator.link.learn_more_label`)}
                  </a>
                </div>
              )}
            </Tooltip>
          }
        >
          <i className="fa-duotone fa-circle-info  cursor-pointer"></i>
        </OverlayTrigger>
      )}
    </div>
  );
};
export default CreatorTitle;
